export default __webpack_public_path__ + "static/media/AssetTable.49821e74.webp";